import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { selectors as ConfigSelectors } from 'data/config'

class DisconnectedStripeAsyncProvider extends Component {
  state = {
    stripe: null,
  }

  componentDidMount() {
    if (window.Stripe) {
      this.setState({
        stripe: window.Stripe(this.props.stripePublicApiKey),
      })
    } else {
      const stripeJs = document.createElement('script')
      stripeJs.src = 'https://js.stripe.com/v3/'
      stripeJs.async = true
      stripeJs.onload = () => {
        this.setState({
          stripe: window.Stripe(this.props.stripePublicApiKey),
        })
      }
      document.body && document.body.appendChild(stripeJs)
    }
  }
  render() {
    return (
      <React.Fragment>
        <StripeProvider stripe={this.state.stripe}>
          <Elements>{this.props.children}</Elements>
        </StripeProvider>
      </React.Fragment>
    )
  }
}

export const StripeAsyncProvider = connect(state => ({
  stripePublicApiKey: ConfigSelectors.getStripePublicApiKey(state),
}))(DisconnectedStripeAsyncProvider)
